import { type ReactElement, useState } from 'react';

import { StaticDataFetcherItem } from '@hh.ru/magritte-common-data-provider';
import { Select } from '@hh.ru/magritte-ui-select';
import type { UncontrolledSelectProps } from '@hh.ru/magritte-ui-select/types';

const UncontrolledSelect = <MultipleType extends boolean, DataType extends StaticDataFetcherItem>({
    name,
    onChange,
    ...props
}: UncontrolledSelectProps<MultipleType, DataType>): ReactElement => {
    const { value } = props;
    const [controlledValue, setValue] = useState(value);
    return (
        <>
            <Select
                {...props}
                onChange={(values) => {
                    setValue(values);
                    onChange?.(values);
                }}
                value={controlledValue}
                name={name}
            />
            {Array.isArray(controlledValue) ? (
                controlledValue.map((value) => (
                    <input type="hidden" name={name} value={value.value} key={value.value} />
                ))
            ) : (
                <input type="hidden" name={name} value={controlledValue?.value} />
            )}
        </>
    );
};

UncontrolledSelect.displayName = 'UncontrolledSelect';

export { UncontrolledSelect };
